// extracted by mini-css-extract-plugin
module.exports = {"downArrowContainer":"down-arrow_downArrowContainer__1EP5N","downArrow":"down-arrow_downArrow__1Pio2","bounce":"down-arrow_bounce__2_RlR"};